<h1 mat-dialog-title>Delivery</h1>
<div mat-dialog-content>
    <p class="card-text">{{data?.name}}</p>
    <p class="card-text">Expected Delivery Date:
        <b>{{data?.customerMaster.customeraddress[0]?.delivery?.deliveryDate | date: 'EEEE, MMMM d, y'}}</b></p>
</div>
<div mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" mat-dialog-close>No Thanks</button>
    <button mat-stroked-button color="accent" mat-dialog-close>OK</button>
</div>